import { Controller } from "@hotwired/stimulus"

// Phase 2.11 Tier 1 — Asset Register list filter chips.
// Auto-submits the enclosing form when any chip / select / search input
// changes so the user gets immediate filter feedback without clicking
// Apply. Mirrors `risk_filter_controller` byte-for-byte; the controller
// name simply scopes the data-action.
export default class extends Controller {
  submit(event) {
    const form = event.target.closest("form")
    if (form) form.requestSubmit()
  }
}
